'use strict';

import type { AgencyDownline } from '../../Entities/Agency/AgencyDownline';
import { EntityCollection } from '../EntityCollection';

export class AgencyDownlineCollection extends EntityCollection<AgencyDownline> {}
